import { JustifyContentType, SxType, gridSize } from "@/shared/constants";
import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";

export interface SampleCheckboxProps {
  label: string;
  onChangeValue?: (e?: boolean) => void;
  size?: { xs: number; sm: number; md: number; lg: number };
  control: Control<any, any>;
  name: string;
  defaultValue: boolean;
  textFieldKey?: string;
  disabled?: boolean;
  justifyContent?: JustifyContentType;
  alignItems?: JustifyContentType;
  checkedIcon?: React.ReactNode;
  sxChecbox?: SxType;
  isState?: boolean;
  textNote?: string;
  sizeCheck?: "small" | "large" | "medium";
  onClickDisabled?: () => void;
  isAutomatic?: boolean;
}

const SampleCheckbox: React.FC<SampleCheckboxProps> = ({
  label,
  name,
  onChangeValue,
  control,
  defaultValue,
  size = gridSize,
  textFieldKey,
  disabled = false,
  alignItems,
  justifyContent,
  checkedIcon,
  sxChecbox,
  isState = false,
  textNote,
  onClickDisabled,
  sizeCheck = "small",
  isAutomatic = false,
}) => {
  const textStyle = { color: "#6C737F" }; // Reusable style constant

  return (
    <Grid
      item
      {...size}
      container
      justifyContent={justifyContent}
      alignItems={alignItems}
      sx={sxChecbox}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        key={textFieldKey ?? defaultValue?.toString()}
        render={({ field }) => {
          const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (disabled) {
              onClickDisabled?.();
              return;
            }
            const isChecked = e.target.checked;
            if (!isAutomatic) {
              onChangeValue?.(isChecked);
            }
            field.onChange(isChecked);
          };

          const renderedLabel = (
            <Typography variant="subtitle2" sx={textStyle}>
              {isState ? (field.value ? "Activo" : "Inactivo") : label}
            </Typography>
          );

          const renderedTextNote = textNote && (
            <Typography variant="subtitle2" sx={textStyle}>
              {textNote}
            </Typography>
          );

          return (
            <>
              <FormControlLabel
                label={renderedLabel}
                control={
                  <Checkbox
                    {...field}
                    size={sizeCheck}
                    checked={!!field.value} // Ensuring value is boolean
                    onChange={handleChange}
                    {...(checkedIcon && { checkedIcon })}
                    sx={{ color: "primary.main" }}
                  />
                }
              />
              {renderedTextNote}
            </>
          );
        }}
      />
    </Grid>
  );
};

export default SampleCheckbox;
